import React, { useRef, FC } from 'react';
import SearchIcon from '@components/searchicon';

import '@styles/searchbar.scss';

export interface SearchBarProps {
  handleSearchTyping: Function;
  placeHolder?: string;
  searchText?: string;
}

const SearchBar: FC<SearchBarProps> = (props: SearchBarProps) => {
  const { handleSearchTyping, placeHolder, searchText } = props;

  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleInput = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const searchValue = event.target.value;
    if (handleSearchTyping) {
      handleSearchTyping(searchValue);
    }
  };

  return (
    <div className="searchbar" data-testid="searchbar">
      <SearchIcon data-testid="searchbar-icon" data-cy="searchbar-icon" />
      <input
        aria-label="searchbar"
        className="searchbar__input"
        data-testid="searchbar-input"
        data-cy="searchbar-input"
        type="text"
        placeholder={placeHolder}
        value={searchText}
        ref={inputRef}
        onChange={handleInput}
        title={placeHolder}
      />
    </div>
  );
};

export default SearchBar;
